import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextBrackets24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTextBrackets24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2 7.25A3.25 3.25 0 0 1 5.25 4h1.5a.75.75 0 0 1 0 1.5h-1.5A1.75 1.75 0 0 0 3.5 7.25v9.5c0 .966.784 1.75 1.75 1.75h1.5a.75.75 0 0 1 0 1.5h-1.5A3.25 3.25 0 0 1 2 16.75zm20 0A3.25 3.25 0 0 0 18.75 4h-1.5a.75.75 0 0 0 0 1.5h1.5c.966 0 1.75.784 1.75 1.75v9.5a1.75 1.75 0 0 1-1.75 1.75h-1.5a.75.75 0 0 0 0 1.5h1.5A3.25 3.25 0 0 0 22 16.75zM8 8.5A.75.75 0 0 0 8 10h8a.75.75 0 0 0 0-1.5zm-.75 3.75A.75.75 0 0 1 8 11.5h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75M8 14.5A.75.75 0 0 0 8 16h5a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextBrackets24);
